import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ScriptSettings } from "@/hooks/useScripts";
import { PreviewDisplay } from "./PreviewDisplay";

interface EditorPreviewPanelProps {
  settings: ScriptSettings;
  content: string;
}

export function EditorPreviewPanel({
  settings,
  content,
}: EditorPreviewPanelProps) {
  const { t } = useTranslation();

  return (
    <Card className="border-2 border-black shadow-[4px_4px_0_#1A1A1A] bg-[#F5F0E8] overflow-hidden lg:flex lg:flex-col lg:h-[calc(62vh+64px)] lg:min-h-[564px]">
      <CardHeader className="pb-3 border-b-2 border-black bg-white shrink-0">
        <CardTitle className="text-base font-bold flex items-center gap-2">
          {t("editor.settings.preview")}
          <span className="text-xs font-normal text-muted-foreground px-2 py-0.5 bg-gray-100 rounded border border-black/20">
            Live
          </span>
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-4 bg-white/50 lg:flex-1 lg:min-h-0">
        <PreviewDisplay 
          content={content} 
          settings={settings} 
          sampleText={t("editor.settings.sampleText")}
          className="h-[300px] lg:h-full"
        />
      </CardContent>
    </Card>
  );
}
